import * as React from "react";

function IconInstagram(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16z"
        fill="#fff"
      />
      <path
        d="M15.985 9.456c2.127 0 2.381 0 3.222.047a4.324 4.324 0 011.48.276 2.65 2.65 0 011.511 1.513c.177.475.27.976.275 1.483.04.842.047 1.098.047 3.228 0 2.131 0 2.386-.047 3.229a4.346 4.346 0 01-.275 1.483 2.654 2.654 0 01-1.51 1.513c-.474.178-.975.27-1.481.275-.84.04-1.092.047-3.222.047s-2.381 0-3.222-.047a4.326 4.326 0 01-1.48-.275 2.65 2.65 0 01-1.494-1.517 4.346 4.346 0 01-.275-1.483c-.04-.842-.047-1.097-.047-3.228 0-2.13 0-2.386.047-3.228a4.346 4.346 0 01.275-1.483 2.656 2.656 0 011.493-1.497c.474-.178.975-.27 1.48-.275.841-.04 1.096-.047 3.223-.047v-.014zm0-1.426c-2.164 0-2.435 0-3.286.047a5.849 5.849 0 00-1.936.373 4.052 4.052 0 00-2.344 2.349 5.878 5.878 0 00-.372 1.94C8.01 13.59 8 13.861 8 16.03s0 2.44.047 3.292c.027.655.162 1.3.402 1.91a4.061 4.061 0 002.344 2.349c.62.232 1.275.358 1.936.372.851.037 1.122.047 3.286.047 2.164 0 2.435 0 3.286-.047a5.847 5.847 0 001.936-.372 4.052 4.052 0 002.344-2.35c.233-.62.358-1.276.372-1.94C23.99 18.44 24 18.169 24 16s0-2.44-.047-3.292a5.879 5.879 0 00-.372-1.94 4.06 4.06 0 00-2.344-2.349 5.849 5.849 0 00-1.936-.372C18.45 8.01 18.179 8 16.015 8l-.03.03z"
        fill="#D50060"
      />
      <path
        d="M15.985 11.9a4.088 4.088 0 00-3.781 2.53 4.109 4.109 0 00.887 4.47 4.09 4.09 0 006.987-2.9c0-1.088-.431-2.13-1.199-2.9a4.09 4.09 0 00-2.894-1.2zm0 6.761a2.653 2.653 0 01-2.454-1.643 2.665 2.665 0 011.936-3.628 2.651 2.651 0 012.726 1.132 2.665 2.665 0 01-.33 3.36 2.654 2.654 0 01-1.878.78zM20.239 12.698a.959.959 0 10-.002-1.918.959.959 0 00.002 1.918z"
        fill="#D50060"
      />
    </svg>
  );
}

export default IconInstagram;
